import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { t as autobizTranslate } from 'autobiz-translate';

class Translate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { code } = this.props;
    if (!code || typeof code !== 'string') return <>{code}</>;
    const message = autobizTranslate(code, this.props);
    if (message) return <>{message}</>;
    return <>{code}</>;
  }
}

export function t(code, variables = null) {
  if (!code || typeof code !== 'string') return code;
  const message = autobizTranslate(code, variables);
  if (message) return message;
  return code;
}

export function translateDate(date, format) {
  const _date = moment(date);
  if (!_date.isValid()) return '';
  return _date.format(t(format));
}

export default Translate;

Translate.propTypes = {
  code: PropTypes.oneOfType([PropTypes.any]),
};

Translate.defaultProps = {
  code: undefined,
};

// translate int
// export function tNum(int) {
//   if (typeof int === 'number') return int.toLocaleString();
//   try {
//     int = parseInt(int, 10);
//     return int.toLocaleString();
//   } catch (e) {
//     //
//   }
//   return int;
// }

// separateur millier
export function numStr(a, b) {
  let _a = a;
  let _b = b;
  if (typeof _a !== 'number') {
    _a = parseInt(_a, 10);
  }
  _a = `${_a}`;
  _b = _b || ' ';
  let c = '';
  let d = 0;
  while (_a.match(/^0[0-9]/)) {
    _a = _a.substr(1);
  }
  for (let i = _a.length - 1; i >= 0; i -= 1) {
    c = d !== 0 && d % 3 === 0 ? _a[i] + _b + c : _a[i] + c;
    d += 1;
  }
  return c;
}
